<template>
	<div>
		<img class="wave" src="../assets/wave.png">
		<div class="login-container">
			<div class="img">
				<!-- <img src="../assets/logo.png" style='width: 100px;' /> -->
				<img src="../assets/bg.svg" />
			</div>
			<div class="login-content">
				<b-form >
					<div >
						<img src="../assets/logo.png">
					</div>
					<br />
					<h3 class="title">{{$lang.login.welcome}}</h3>
					<b-alert :show="errorMsg != ''" dismissible variant="danger">{{errorMsg}}</b-alert>
					<div v-bind:class="{focus: loginForm.usernameFocus || loginForm.username.length > 0}">
						<!-- <div class="i">
							<font-awesome-icon icon="user" />
						</div> -->
						<div >
						<h5>{{$lang.login.username}}</h5>
						<b-form-input type="text" v-model="loginForm.username" @focus="loginForm.usernameFocus = true" @blur="loginForm.usernameFocus = false"></b-form-input>
						</div>
					</div>
					<br />
					<div class="input-div pass" v-bind:class="{focus: loginForm.passwordFocus || loginForm.password.length > 0}">
						<!-- <div class="i">
							<font-awesome-icon icon="lock" />
						</div> -->
						<div class="div">
						<h5>{{$lang.login.password}}</h5>
						<b-form-input type="password" v-model="loginForm.password" @focus="loginForm.passwordFocus = true" @blur="loginForm.passwordFocus = false"></b-form-input>
						</div>
					</div>
					<br />
					<a href="#">{{$lang.login.forgotPassword}}</a>
					<div>
						<b-button variant="primary" block v-on:click="login()" value="Login" v-if="performingRequest == false">{{$lang.login.login}}</b-button>
						<b-button variant="primary" block value="Login" v-if="performingRequest == true" ><b-spinner label="Spinning" style="width: 1.3rem; height: 1.3rem;"></b-spinner></b-button>
					</div>
				</b-form>
			</div>
		</div>
	</div>
</template>

<script>

const fb = require('../firebaseConfig.js')
export default {

	data() {
		return {
			loginForm: {
				username: '',
				password: '',
				usernameFocus: false,
				passwordFocus: false
			},
			value: '',
			errorMsg: '',
            performingRequest: false,
		}
	},

	methods: {
		login() {
			this.errorMsg = ''
			this.performingRequest = true
			fb.auth.setPersistence(fb.authPersistence.SESSION).then(() => {
				fb.auth.signInWithEmailAndPassword(this.loginForm.username, this.loginForm.password).then(user => {
					console.log()
					this.$store.commit('setCurrentUser', user.user)
					this.$store.dispatch('fetchUserProfile')
					this.$store.dispatch('fetchContractTypes')
					this.performingRequest = false
					this.$router.push('/dashboard')
				}).catch(err => {
					console.log(err.message)
					this.errorMsg = err.message
					this.performingRequest = false
				})
			})
		},
	}
}
</script>
